import { useQuery } from "react-query"

import { subscriptionApi } from "../../api"

/** Obtains FAQ content from CRM to render of faq screen as accordion view. */
export function useGetFaqQuery(config) {
  return useQuery("getFaq", () => subscriptionApi.getFaq(), config)
}
